import { composeDecorators } from '@draft-js-plugins/editor';

import createFocusPlugin from '@draft-js-plugins/focus';

import createVidPlugin from './vid';
import highlight from './highlight';
import createMyImgPlugin from './img';
import createEmbedPlugin from './embed';
import createPDFPlugin from './pdf';

function plugins() {
  const focusPlugin = createFocusPlugin();
  const highlightPlugin = highlight();
  const decorator = composeDecorators(
    focusPlugin.decorator,
  );
  const imagePlugin = createMyImgPlugin({ decorator });
  const vidPlugin = createVidPlugin({ decorator });
  const embedPlugin = createEmbedPlugin();
  const pdfPlugin = createPDFPlugin();

  return ({
    imagePlugin,
    vidPlugin,
    embedPlugin,
    pdfPlugin,
    plugins: [focusPlugin, highlightPlugin, imagePlugin, vidPlugin, embedPlugin, pdfPlugin],
  });
}

export default plugins;
